(() => {
  const STYLE_ID = 'nomitail-easy-bundles-style';
  const NESTED_STYLE_ID = 'nomitail-easy-bundles-nested-style';
  const observedRoots = new WeakSet();
  const queuedHosts = new WeakSet();

  const volumeStyles = `
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      color: #111516 !important;
      font-family: var(--font-body--family, Arial, sans-serif) !important;
    }

    .cartmax-card-volume {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      gap: 12px !important;
      margin: 16px 0 0 !important;
      padding: 16px !important;
      overflow: hidden !important;
      border: 1px solid #dfe3e6 !important;
      border-radius: 12px !important;
      background: #ffffff !important;
      box-shadow: 0 6px 20px rgb(17 21 22 / 0.06) !important;
    }

    .cartmax-top {
      gap: 8px !important;
    }

    .cartmax-top .cartmax-title {
      flex: 0 1 auto !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #d4a15d !important;
      font-family: var(--font-heading--family, var(--font-body--family, Arial, sans-serif)) !important;
      font-size: 18px !important;
      font-weight: 750 !important;
      line-height: 1.2 !important;
      text-align: center !important;
    }

    .cartmax-top .cartmax-line {
      height: 2px !important;
      background: #ffc107 !important;
    }

    .cartmax-countdown-timer {
      margin: 0 !important;
      color: #d4a15d !important;
    }

    cartmax-countdown-time {
      --countdown-color: #d4a15d !important;
      --countdown-font-size: 14px !important;
    }

    .cartmax-card-vertical-wrapper {
      margin-top: 0 !important;
      overflow: hidden visible !important;
    }

    .cartmax-card-vertical {
      box-sizing: border-box !important;
      gap: 10px !important;
      padding: 2px !important;
      --cm-carousel-item-width: 100% !important;
    }

    .cartmax-carousel-dots {
      gap: 7px !important;
      padding: 0 !important;
    }

    .cartmax-dot {
      width: 7px !important;
      height: 7px !important;
      background: #d4d8dd !important;
    }

    .cartmax-dot.active,
    .cartmax-dot.active:hover {
      width: 8px !important;
      height: 8px !important;
      background: #ffc107 !important;
      opacity: 1 !important;
    }

    vertical-layout > div {
      padding: 0 10px 10px !important;
      color: #111516 !important;
    }

    vertical-layout > div > div {
      gap: 4px !important;
    }

    vertical-layout > div [style*="width: 40px"] {
      width: 32px !important;
      height: 32px !important;
      margin-bottom: 6px !important;
    }

    vertical-layout > div [style*="width: 140px"] {
      width: 100% !important;
      max-width: 140px !important;
    }

    vertical-layout[data-nomitail-bundle-layout='single'] > div [style*="width: 140px"] {
      max-width: 220px !important;
    }

    @media screen and (max-width: 749px) {
      .cartmax-card-volume {
        gap: 10px !important;
        margin-top: 12px !important;
        padding: 12px !important;
        border-radius: 10px !important;
        box-shadow: 0 4px 14px rgb(17 21 22 / 0.05) !important;
      }

      .cartmax-top {
        gap: 6px !important;
      }

      .cartmax-top .cartmax-title {
        font-size: 16px !important;
      }

      .cartmax-top .cartmax-line {
        height: 1.5px !important;
      }

      cartmax-countdown-time {
        --countdown-font-size: 13px !important;
      }

      .cartmax-card-vertical {
        gap: 8px !important;
        --cm-carousel-item-width: 100% !important;
      }

      vertical-layout > div {
        padding: 0 8px 8px !important;
      }

      vertical-layout > div [style*="width: 40px"] {
        width: 28px !important;
        height: 28px !important;
        margin-bottom: 4px !important;
      }
    }
  `;

  const verticalStyles = `
    .cart-card {
      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      background: #ffffff !important;
    }

    .cart-card-wrap,
    .cart-card-label,
    .cart-card-label-content {
      width: 100% !important;
      min-width: 0 !important;
    }

    .cart-card-active {
      background: #fff9e6 !important;
    }

    .cart-card-label {
      box-sizing: border-box !important;
      padding: 12px !important;
    }

    .cart-card-label-content {
      gap: 10px !important;
    }

    .cart-title {
      margin-top: 2px !important;
      color: #111516 !important;
      font-size: 15px !important;
      font-weight: 700 !important;
      line-height: 1.25 !important;
    }

    .custom-radio-content cartmax-animo-img {
      width: 82px !important;
      height: 82px !important;
    }

    .cart-price {
      margin-bottom: 2px !important;
      color: #d20c0c !important;
      font-size: 15px !important;
      font-weight: 750 !important;
    }

    .cart-old-price,
    .cart-remark {
      color: #737b85 !important;
      font-size: 12px !important;
    }

    @media screen and (max-width: 749px) {
      .cart-card-label {
        padding: 10px !important;
      }

      .cart-card-label-content {
        gap: 8px !important;
      }

      .cart-title {
        font-size: 14px !important;
      }

      .custom-radio-content cartmax-animo-img {
        width: 72px !important;
        height: 72px !important;
      }

      .cart-price {
        font-size: 14px !important;
      }
    }
  `;

  const badgeStyles = `
    :host {
      color: #111516 !important;
    }

    .cartmax-bage,
    .cartmax-badge,
    [class*='bage'],
    [class*='badge'] {
      border-radius: 999px !important;
      background: #ffc107 !important;
      color: #111516 !important;
      font-weight: 750 !important;
    }

    span {
      color: #111516 !important;
      font-weight: 750 !important;
    }
  `;

  const countdownStyles = `
    :host {
      color: #d4a15d !important;
    }

    * {
      color: #d4a15d !important;
      font-weight: 650 !important;
    }
  `;

  const ensureStyle = (root, id, cssText) => {
    if (!root || root.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = cssText;
    root.appendChild(style);
  };

  const setImportant = (element, property, value) => {
    element?.style?.setProperty(property, value, 'important');
  };

  const observeRoot = (root, callback) => {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    new MutationObserver(callback).observe(root, { childList: true, subtree: true });
  };

  const styleBadge = (badge) => {
    setImportant(badge, '--bage-background-color', '#ffc107');
    setImportant(badge, '--badge-background-color', '#ffc107');
    setImportant(badge, '--bage-text-color', '#111516');
    setImportant(badge, '--badge-text-color', '#111516');
    setImportant(badge, '--text-color', '#111516');
    if (badge.shadowRoot) ensureStyle(badge.shadowRoot, NESTED_STYLE_ID, badgeStyles);
  };

  const styleSelect = (select) => {
    setImportant(select, '--border-radius', '8px');
    setImportant(select, '--font-size', '13px');
    setImportant(select, '--trigger-line-height', '28px');
    setImportant(select, '--text-color', '#111516');
    setImportant(select, '--border-color', '#cfd4da');
    setImportant(select, '--icon-color', '#111516');
    setImportant(select, '--background-color', '#ffffff');
    setImportant(select, '--background-color-active', '#fff9e6');
    setImportant(select, '--popups-background-color', '#ffffff');
  };

  const styleCountdown = (countdown) => {
    setImportant(countdown, '--countdown-color', '#d4a15d');
    setImportant(countdown, '--countdown-font-size', window.matchMedia('(max-width: 749px)').matches ? '13px' : '14px');
    if (countdown.shadowRoot) ensureStyle(countdown.shadowRoot, NESTED_STYLE_ID, countdownStyles);
  };

  const styleVertical = (vertical, layout) => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const singleCard = layout === 'single';
    vertical.dataset.nomitailBundleLayout = layout;
    const properties = {
      '--cart-hover-background': '#fff9e6',
      '--subtitle-color-remark': '#737b85',
      '--selected-cart-border-color': '#111516',
      '--unselected-cart-border-color': '#dfe3e6',
      '--cart-gift-price--text-color': '#111516',
      '--cart-old-gift-color': '#737b85',
      '--cart-price-text-color': '#d20c0c',
      '--cart-title-text-color': '#111516',
      '--cart-title-text-font-size': mobile ? '14px' : '15px',
      '--cart-remark-font-size': '12px',
      '--cart-gift-padding': mobile ? '8px' : '10px',
      '--cart-select-background-color': '#fff9e6',
      '--cart-un-select-background-color': '#ffffff',
      '--cart-background-color': '#ffffff',
      '--selected-border-width': '2px',
      '--unselected-border-width': '1px',
      '--product-image-radius': '8px',
      '--cart-padding': mobile ? '10px' : '12px',
      '--cart-border-color': '#dfe3e6',
      '--cart-border-radius': '10px',
      '--text-color': '#111516',
      '--title-font-size': mobile ? '14px' : '15px',
      '--old-and-subtitle-color': '#737b85',
      '--old-price-font-size': '12px',
      '--bage-text-color': '#111516',
      '--tag-text-color': '#111516',
      '--image-size': singleCard ? (mobile ? '96px' : '104px') : '76px',
      '--image-radius': '8px',
    };

    Object.entries(properties).forEach(([property, value]) => setImportant(vertical, property, value));

    const root = vertical.shadowRoot;
    if (!root) return;
    ensureStyle(root, STYLE_ID, verticalStyles);
    root.querySelectorAll('.custom-radio-content cartmax-animo-img').forEach((image) => {
      const imageSize = singleCard ? (mobile ? '96px' : '104px') : '76px';
      setImportant(image, 'width', imageSize);
      setImportant(image, 'height', imageSize);
    });
    root.querySelectorAll('cartmax-bage').forEach(styleBadge);
    root.querySelectorAll('cartmax-select-pro').forEach(styleSelect);
    observeRoot(root, () => queueVolume(vertical.getRootNode()?.host));
  };

  const centerCarousel = (host, layout) => {
    const root = host?.shadowRoot;
    const carousel = root?.querySelector('.cartmax-card-vertical');
    if (!carousel) return;

    if (layout === 'triple') {
      carousel.scrollLeft = 0;
      return;
    }

    const activeVertical = [...root.querySelectorAll('vertical-layout')]
      .find((vertical) => vertical.shadowRoot?.querySelector('.cart-card-active'));
    const activeSlide = activeVertical?.parentElement;
    if (!activeSlide) return;

    const carouselRect = carousel.getBoundingClientRect();
    const activeRect = activeSlide.getBoundingClientRect();
    const centeredOffset = activeRect.left - carouselRect.left - (carouselRect.width - activeRect.width) / 2;
    carousel.scrollLeft = Math.max(0, carousel.scrollLeft + centeredOffset);
  };

  const scheduleCarouselPosition = (host, layout) => {
    [0, 120, 400, 900, 1500].forEach((delay) => {
      window.setTimeout(() => {
        if (host.dataset.nomitailBundleLayout !== layout) return;
        window.requestAnimationFrame(() => centerCarousel(host, layout));
      }, delay);
    });
  };

  const applyVolume = (host) => {
    if (!host?.shadowRoot) return;
    const root = host.shadowRoot;
    ensureStyle(root, STYLE_ID, volumeStyles);

    const hostWidth = Math.round(host.getBoundingClientRect().width);
    const layout = hostWidth >= 480 ? 'triple' : 'single';
    const layoutChanged = host.dataset.nomitailBundleLayout !== layout;
    const widthChanged = host.dataset.nomitailBundleWidth !== String(hostWidth);
    host.dataset.nomitailBundleLayout = layout;
    host.dataset.nomitailBundleWidth = String(hostWidth);

    const carousel = root.querySelector('.cartmax-card-vertical');
    if (carousel) {
      const gap = layout === 'triple' ? '10px' : '8px';
      const itemWidth = layout === 'triple' ? 'calc((100% - 20px) / 3)' : '100%';
      setImportant(carousel, 'gap', gap);
      setImportant(carousel, '--cm-carousel-item-width', itemWidth);
    }

    const verticals = [...root.querySelectorAll('vertical-layout')];
    verticals.forEach((vertical) => styleVertical(vertical, layout));
    root.querySelectorAll('cartmax-bage').forEach(styleBadge);
    root.querySelectorAll('cartmax-select-pro').forEach(styleSelect);
    root.querySelectorAll('cartmax-countdown-time').forEach(styleCountdown);
    observeRoot(root, () => queueVolume(host));

    if ((layoutChanged || widthChanged) && carousel) scheduleCarouselPosition(host, layout);
  };

  function queueVolume(host) {
    if (!host || queuedHosts.has(host)) return;
    queuedHosts.add(host);
    window.requestAnimationFrame(() => {
      queuedHosts.delete(host);
      applyVolume(host);
    });
  }

  const applyAll = () => document.querySelectorAll('volume-card').forEach(queueVolume);

  new MutationObserver(applyAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', applyAll);
  window.addEventListener('pageshow', applyAll);
  window.addEventListener('resize', applyAll);

  applyAll();
  let attempts = 0;
  const timer = window.setInterval(() => {
    applyAll();
    attempts += 1;
    if (attempts >= 90) window.clearInterval(timer);
  }, 500);
})();
